import { defineStore } from 'pinia'
export const useNotificationStore = defineStore('notification', {
  state: () => ({
    notifications: {},
    notificationcount: 0,
    loading: false,
  }),
  actions: {
    async getAllNotification() {
      try {
        let { data } = await this.$axiosInstance.get('Notification', {
          params: {
            global: true,
          },
        })

        this.notifications = data.data
        this.notificationcount = this.notifications.length
      } catch (error) {
        console.log('error', error)
      }
    },
    async removeNotification(notificationID) {
      try {
        let { data } = await this.$axiosInstance.delete('/Notification/', {
          data: notificationID,
        })

        if (data.success && data.data)
          this.removeNotificationAction(notificationID)
      } catch (error) {}
    },
    async removeAllNotification() {
      let notificationIDs = []
      if (this.notifications.length) {
        this.notifications.forEach((element) => {
          notificationIDs.push(element.notificationID)
        })
        try {
          this.loading = true
          let { data } = await this.$axiosInstance.delete('/Notification/', {
            data: notificationIDs,
          })

          if (data.success && data.data) {
            this.notifications = {}
            this.notificationcount = 0
          }
        } catch (error) {
        } finally {
          this.loading = false
        }
      }
    },
    removeNotificationAction(notificationID) {
      this.notifications = this.notifications.filter(
        (obj) => obj.notificationID !== notificationID[0]
      )

      this.notificationcount = this.notifications.length
    },
  },
})
